var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27237 16.5486C5.30565 16.2491 5.32229 16.0994 5.3676 15.9594C5.4078 15.8352 5.4646 15.7171 5.53646 15.6081C5.61745 15.4853 5.72399 15.3787 5.93708 15.1656L15.5027 5.60005C16.3027 4.79998 17.5999 4.79998 18.4 5.60005C19.2 6.40011 19.2 7.69727 18.4 8.49734L8.83436 18.0629C8.62128 18.276 8.51474 18.3826 8.39192 18.4635C8.28295 18.5354 8.16477 18.5922 8.04059 18.6324C7.90062 18.6777 7.75087 18.6943 7.45137 18.7276L5 19L5.27237 16.5486Z",
    stroke: "#3C4549",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionEdit);
export default __webpack_public_path__ + "static/media/questionEdit.41645e142d9bb58ef9383f29c4543749.svg";
export { ForwardRef as ReactComponent };